const HOUR_MS = 3_600_000
const DAY_MS = 86_400_000

const AT_WORD = {
  de: "um",
  el: "στις",
  es: "a las",
  fr: "à",
  it: "alle",
  pt: "às",
}

export function formatSlotPostedAt(iso, {now = Date.now(), locale} = {}) {
  if (!iso) return ""
  const at = iso instanceof Date ? iso : new Date(iso)
  if (Number.isNaN(at.getTime())) return ""

  const resolved = locale || defaultLocale()
  const diffMs = now - at.getTime()
  if (diffMs >= 0 && diffMs < DAY_MS) {
    return formatRecent(diffMs, resolved)
  }
  return formatCelebratory(at, resolved)
}

function formatRecent(diffMs, locale) {
  const rtf = new Intl.RelativeTimeFormat(locale, {numeric: "always"})
  const hours = Math.floor(diffMs / HOUR_MS)
  if (hours < 1) {
    const minutes = Math.max(1, Math.floor(diffMs / 60_000))
    return rtf.format(-minutes, "minute")
  }
  return rtf.format(-hours, "hour")
}

function formatCelebratory(date, locale) {
  const weekday = titleCase(new Intl.DateTimeFormat(locale, {weekday: "long"}).format(date))
  const month = titleCase(new Intl.DateTimeFormat(locale, {month: "long"}).format(date))
  const day = ordinalDay(date.getDate(), locale)
  const year = date.getFullYear()
  const time = new Intl.DateTimeFormat(locale, {
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).format(date)
  const at = atWord(locale)
  return `${weekday}, ${month} ${day}, ${year} ${at} ${time}`
}

function ordinalDay(n, locale) {
  if (!String(locale).toLowerCase().startsWith("en")) return String(n)
  const v = n % 100
  if (v >= 11 && v <= 13) return `${n}th`
  switch (n % 10) {
    case 1:
      return `${n}st`
    case 2:
      return `${n}nd`
    case 3:
      return `${n}rd`
    default:
      return `${n}th`
  }
}

function atWord(locale) {
  const lang = String(locale).split("-")[0].toLowerCase()
  return AT_WORD[lang] || "at"
}

function defaultLocale() {
  if (typeof navigator !== "undefined" && navigator.language) return navigator.language
  return "en"
}

function titleCase(s) {
  if (!s) return s
  return s.charAt(0).toLocaleUpperCase() + s.slice(1)
}
